/* 4Leader landing motion. Carregado uma vez, mesmo com várias seções lp-* na página. */
(function () {
  if (window.__lpMotion) return;
  window.__lpMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal ---- */
  function revealAll() {
    document.querySelectorAll('[data-lp-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    document.querySelectorAll('.lp-chapter').forEach(function (el) { el.classList.add('is-in'); });
  }
  if (reduce || !('IntersectionObserver' in window)) { revealAll(); }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('is-in');
      if (el.hasAttribute('data-lp-count')) countUp(el);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }) : null;

  function observe() {
    if (!io || reduce) return;
    document.querySelectorAll('[data-lp-reveal], .lp-chapter, [data-lp-count]').forEach(function (el) {
      if (!el.__lpObs) { el.__lpObs = true; io.observe(el); }
    });
  }

  /* ---- números que sobem (6h, 20h, 100 avaliações) ---- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-lp-count'));
    if (isNaN(target)) return;
    var decimals = (String(el.getAttribute('data-lp-count')).split('.')[1] || '').length;
    var duration = 1100, start = null;
    var span = el.querySelector('[data-lp-count-value]') || el;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      span.textContent = (target * eased).toFixed(decimals).replace('.', ',');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---- hero: imagem afasta levemente ao rolar ---- */
  var heroMedia = document.querySelector('[data-lp-parallax]');
  if (heroMedia) {
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || window.pageYOffset;
        var h = heroMedia.parentElement.offsetHeight || 1;
        var p = Math.min(y / h, 1);
        heroMedia.style.transform = 'translate3d(0,' + (p * 12) + '%,0) scale(' + (1 + p * 0.06) + ')';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- CTA magnético: o botão "puxa" na direção do cursor (só desktop com mouse) ---- */
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var MAG_MAX = 16;
  function bindMagnetic() {
    if (!finePointer || reduce) return;
    document.querySelectorAll('[data-lp-magnetic]').forEach(function (btn) {
      if (btn.__lpMag) return;
      btn.__lpMag = true;
      var pull = parseFloat(btn.getAttribute('data-lp-magnetic')) || 0.3;
      var pad = 56;
      var cx = 0, cy = 0, x = 0, y = 0, raf = null, near = false;

      function frame() {
        x += (cx - x) * 0.16;
        y += (cy - y) * 0.16;
        if (!near && Math.abs(cx - x) < 0.15 && Math.abs(cy - y) < 0.15) {
          x = 0; y = 0; btn.style.transform = ''; raf = null; return;
        }
        btn.style.transform = 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px)';
        raf = requestAnimationFrame(frame);
      }
      function run() { if (!raf) raf = requestAnimationFrame(frame); }
      function clamp(v) { return v < -MAG_MAX ? -MAG_MAX : (v > MAG_MAX ? MAG_MAX : v); }

      function onMove(e) {
        var r = btn.getBoundingClientRect();
        if (!r.width) return;
        var inside = e.clientX >= r.left - pad && e.clientX <= r.right + pad &&
                     e.clientY >= r.top - pad && e.clientY <= r.bottom + pad;
        if (inside) {
          near = true;
          cx = clamp((e.clientX - (r.left + r.width / 2)) * pull);
          cy = clamp((e.clientY - (r.top + r.height / 2)) * pull);
          run();
        } else if (near) {
          near = false; cx = 0; cy = 0; run();
        }
      }
      function release() { near = false; cx = 0; cy = 0; run(); }
      window.addEventListener('mousemove', onMove, { passive: true });
      window.addEventListener('blur', release);
      btn.addEventListener('mouseleave', release);
    });
  }

  /* ---- vídeos: força play ao entrar na tela; tenta de novo no 1º toque se o sistema bloquear ---- */
  var blocked = [];
  function tryPlay(v) {
    if (!v.paused) return;
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { if (blocked.indexOf(v) < 0) blocked.push(v); });
  }
  function retryOnGesture() {
    if (!blocked.length) return;
    var list = blocked.slice(); blocked = [];
    list.forEach(tryPlay);
  }
  ['touchstart', 'scroll', 'click'].forEach(function (ev) {
    window.addEventListener(ev, retryOnGesture, { passive: true, once: false });
  });
  var vio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) tryPlay(v); else if (!v.paused) v.pause();
    });
  }, { threshold: 0.2 });
  function watchVideos() {
    document.querySelectorAll('.lp video').forEach(function (v) {
      if (v.__lpV) return; v.__lpV = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('autoplay', '');
      vio.observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchVideos); else watchVideos();
  document.addEventListener('shopify:section:load', watchVideos);

  /* ---- rolagem suave para o bloco de compra ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#comprar"]');
    if (!a) return;
    var target = document.getElementById('comprar');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function init() { observe(); bindMagnetic(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
